import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { toothModel } from '@/entities/tooth';

import { ToothChartContext } from '../ToothChartRoot/ToothChartRoot';

import styles from './ToothChartHeader.module.scss';

type ToothChartHeaderProps = {
  children?: React.ReactNode;
  hideTitle?: boolean;
};

export const ToothChartHeader = (props: ToothChartHeaderProps) => {
  const { children, hideTitle } = props;

  const { formatMessage } = useIntl();

  const size = useContext(ToothChartContext);

  const customMode = useAppSelector(
    toothModel.selectors.selectToothChartCustomMode,
  );

  const title = customMode
    ? formatMessage({
        id: 'toothChart.titleCustomMode',
        defaultMessage: 'Select teeth',
      })
    : formatMessage({
        id: 'toothChart.title',
        defaultMessage: 'Teeth in the report',
      });

  return (
    <header className={styles.container} data-component="tooth-chart-header">
      {!hideTitle ? (
        <h2 className={size === 'default' ? 'h4' : 'h5'}>{title}</h2>
      ) : null}
      {children}
    </header>
  );
};
